import { Post } from "../../helpers/apicalls/apicalls";
import * as actionTypes from "./FaqsTypes";
import { message } from "antd";

export const getFaqsContent = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_FAQS,
    });
    Post("/agents/user/faqs-content", data)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.FAQS_DATA_SUCCESS,
            payload: res.data
          });
        }
        else {
          message.error(`${res?.message}`)
          dispatch({
            type: actionTypes.FAQS_DATA_FAILED
          });
        }
      })
      .catch((err) => {
        message.error(`${err?.message}`)
        dispatch({
          type: actionTypes.FAQS_DATA_FAILED
        });
      });
  };
};

export const saveFaqsContent = (data, token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_SAVE_FAQS,
    });
    Post("/agents/user/save-faqs-content", data, token)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.SAVE_FAQS_DATA_SUCCESS,
            payload: res.data
          });
          dispatch(getFaqsContent({
            companyId: res?.data?.companyId,
            websiteToken: res?.data?.websiteToken
          }, token));
          message.success(`${res?.message}`)
        }
        else {
          message.error(`${res?.message}`)
          dispatch({
            type: actionTypes.SAVE_FAQS_DATA_FAILED
          });
        }
      })
      .catch((err) => {
        message.error(`${err?.message}`)
        dispatch({
          type: actionTypes.SAVE_FAQS_DATA_FAILED
        });
      });
  };
};
